// extracted by mini-css-extract-plugin
module.exports = {"root":"FilterMenuFooter_root__UAM6a"};